import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import Form from './form';
import {
  fetch,
  saveAssistance,
  updatePresenceStundent,
} from '../../../redux/actions/assistanceActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import debounce from '../../../helpers/debounce';

class AssistanceFormContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      assistance: {
        reference: '',
        date: '',
        room: '',
        logContent: { value: 0 },
        students: [],
      },
      loading: false,
      filterValue: '',
      sortColumn: 'surname',
      sortType: 'desc',
    };

    this.debouncedAutoSavePresent = debounce(this.autoSavePresent, 500);
  }

  componentDidMount() {
    const { id } = this.props;
    this.getAssistance({ id });
  }

  getAssistance = ({ id }) => {
    if (!id) {
      this.setState({
        assistance: {},
        loading: false,
      });

      return;
    }

    this.setState({
      loading: true,
    });

    fetch({
      id,
      onSuccess: ({
        date, room, reference, logContent, canEdit, endHomework, students = [],
      }) => {
        this.setState({
          assistance: {
            id,
            date: date.split('T')[0],
            room,
            reference,
            logContent,
            endHomework,
            canEdit,
            students,
          },
          loading: false,
        });
      },
      onError: (error) => {
        this.setState({
          assistance: {},
          loading: false,
        });

        if (error && error.status === 404) {
          createWarningMessage('La asistencia no existe');
          return;
        }

        createErrorMessage('Error al intentar cargar los datos de la asistencia');
      },
    });
  }

  handleSubmit = (values = {}) => {
    if (!Object.entries(values).length) return;

    this.setState({ loading: true });
    const {
      id,
      logContent = { value: null },
      room,
      reference,
      date,
      present = false,
    } = values;

    const { subjectPeriodId } = this.props;

    saveAssistance({
      payload: {
        id,
        subjectPeriodId,
        logContentId: logContent && logContent.value,
        room,
        reference,
        date,
        present,
      },
      onSuccess: ({ payload = {} }) => {
        this.setState({
          ...payload,
          loading: false,
        });
        this.handleOnBack();
        createSuccessMessage('Asistencia guardado exitosamente');
      },
      onError: (error) => {
        this.setState({ loading: false });

        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la asistencia');
        }
      },
    });
  }

  handleOnBack = () => {
    const { onHideForm } = this.props;
    onHideForm();
  }

  handleChangeChecked = ({
    name,
    target = {},
    doc,
  }) => {
    if (target.checked === undefined) {
      return;
    }

    const value = target.checked;
    if (doc) {
      const { assistance } = this.state;
      const items = assistance[name];

      const newArray = [...items];
      const index = newArray.findIndex(item => item.doc === doc);

      newArray[index] = {
        ...newArray[index],
        ...{
          [target.name.split('.')[1]]: value,
        },
      };

      this.setState({
        assistance: {
          ...assistance,
          [name]: newArray,
        },
      });

      this.debouncedAutoSavePresent({ ...newArray[index], assistanceId: assistance.id });
      return;
    }

    this.setState(prev => ({
      assistance: {
        ...prev.assistance,
        ...{
          [target.name]: value,
        },
      },
    }));
  };

  handleSort = ({ sortColumn, sortType }) => {
    this.setState({
      sortColumn,
      sortType: sortType === 'desc' ? 'asc' : 'desc',
    });
  };

  handleFilterChangeText = ({ target: { value } }) => {
    this.setState({ filterValue: value });
  };

  handleChangeText = ({ target: { name, value } }) => {
    const { assistance } = this.state;
    this.setState({
      assistance: {
        ...assistance,
        [name]: value,
      },
    });
  };

  transformText = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  getStudents = () => {
    const {
      filterValue = '',
      sortColumn,
      sortType,
      assistance: { students = [] },
    } = this.state;

    const filter = this.transformText(filterValue);
    const result = students
      .filter(tma => (
        this.transformText(tma.doc).includes(filter)
        || this.transformText(tma.name).includes(filter)
        || this.transformText(tma.surname).includes(filter)
      ))
      .sort((a, b) => (sortType !== 'asc'
        ? a[sortColumn].localeCompare(b[sortColumn])
        : b[sortColumn].localeCompare(a[sortColumn])
      ));

    return result;
  };

  autoSavePresent = (row = {}) => {
    const {
      assistanceId,
      studentId,
      present,
    } = row;

    if (!assistanceId || present == null) return;

    updatePresenceStundent({
      assistanceId,
      payload: {
        assistanceId,
        studentId,
        present,
      },
      onSuccess: () => {
        createSuccessMessage('Asistencia actualizado exitosamente.');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la asistencia.');
        }
      },
    });
  };

  assistanceForm = () => {
    const {
      id,
      logContents,
      endHomework,
    } = this.props;

    const {
      assistance,
      loading,
      filterValue,
      sortColumn,
      sortType,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    return (
      <Form
        {...assistance}
        id={id}
        logContents={logContents}
        endHomework={endHomework}
        students={this.getStudents()}
        filterValue={filterValue}
        onSubmit={this.handleSubmit}
        onBack={this.handleOnBack}
        loading={loading}
        initialValues={assistance}
        sortColumn={sortColumn}
        sortType={sortType}

        onChangeChecked={this.handleChangeChecked}
        handleSort={this.handleSort}
        handleFilterChangeText={this.handleFilterChangeText}
        handleChangeText={this.handleChangeText}

        enableReinitialize
      />
    );
  }

  render() {
    const {
      id,
    } = this.props;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} asistencia
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              asistencia
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={12}>
            {this.assistanceForm()}
          </Col>
        </Row>
      </Container>
    );
  }
}

AssistanceFormContainer.propTypes = {
  id: PropTypes.number.isRequired,
  subjectPeriodId: PropTypes.number.isRequired,
  endHomework: PropTypes.string.isRequired,
  logContents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onHideForm: PropTypes.func.isRequired,
};

export default AssistanceFormContainer;
